<template>
  <div>
    <div class="m_flex_row" style="margin:30px">
      项目名称：
      <a-input
        placeholder="请输入项目明名称"
        @change="nameChange"
        v-model="key"
        style="width:300px;margin-left:20px;margin-right:100px;"
      />

      <a-button type="primary" icon="search" style="margin-right:50px">搜索</a-button>

      <a-button type="primary" icon="plus" @click="goAddProject">创建项目</a-button>
    </div>

    <a-table :columns="columns" :dataSource="data" bordered :pagination="false">
      

      <template slot="people_count" slot-scope="text, record,index">
        <a @click="() => goPeopleList(record.key)">{{text}}</a>
      </template>

      <template slot="operation" slot-scope="text, record">
        <a @click="() => edit(record.key)">编辑</a>
        <a-divider type="vertical" />
        <a @click="() => goVersions(record.key)">历史版本</a>
        <a-divider type="vertical" />
        <a @click="() => goAllDoctor(record.key)">研究者管理</a>

        <a-divider type="vertical" />
        <a-popconfirm
          v-if="!record.is_delete"
          title="确定取消这次项目吗?"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">取消</a>
        </a-popconfirm>
        <a-popconfirm v-else title="确定重启开启吗？" @confirm="() => getBack(record.key)">
          <a href="javascript:;">重新开启</a>
        </a-popconfirm>
      </template>
    </a-table>
    <div style="text-align:center;margin-top:30px;">
      <a-pagination :total="total" @change="changePage" show-less-items />
    </div>
  </div>
</template>
<script>
import request from "../../utils/request";
const columns = [
  {
    title: "序号",
    dataIndex: "the_id",
    width: "10%"
  },
  {
    title: "项目名称",
    dataIndex: "item.name",
    width: "20%"
  },
  {
    title: "最新版本",
    dataIndex: "version_code_text",
    width: "10%"
  },
  {
    title: "当前测试人数",
    dataIndex: "people_count",
    scopedSlots: { customRender: "people_count" },
    width: "10%"
  },
  {
    title: "状态",
    dataIndex: "is_delete_text",
    width: "10%"
  },
  {
    title: "创建时间",
    dataIndex: "create_time",
    width: "10%"
  },
  {
    title: "操作",
    width: "30%",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];

export default {
  data() {
    return {
      total: 0,
      current_page: 0,
      data: [],
      columns,
      searchText: "",
      searchInput: null,
      key: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    changePage(page, pageSize) {
      this.current_page = page - 1;
      console.log(page, pageSize, this.current_page);
      this.getData();
    },
    nameChange(e) {
      console.log(this.key, e);
      this.getData();
    },
    goAddProject() {
      this.$router.push({
        path: "/project/add"
      });
    },
    goPeopleList(key) {
      this.$router.push({
        path: "/project/people/list",
        query: { the_id: key }
      });
    },
    getData() {
      request({
        url: "/project/",
        method: "get",
        params: {
          page: this.page,
          page_size: 10,
          key: this.key
        }
      }).then(response => {
       
        if (response.data.success) {
          const list = response.data.data;
          let i = this.current_page * 10 + 1;

          this.data = list.map(item => {
            item["the_id"] = i;
            i += 1;
            return item;
          });
           console.log("获取到的参数", this.data);
          this.total = response.data.total;
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    handleSearch(selectedKeys, confirm) {
      confirm();
      this.searchText = selectedKeys[0];
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    onDelete(key) {
      request({
        url: "/project/" + key + "/",
        method: "delete",
        params: {}
      }).then(response => {
        console.log("111");
        if (response.data.success) {
          this.getData();
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    getBack(key) {
      request({
        url: "/project/getback/" + key,
        method: "put",
        params: {}
      }).then(response => {
        this.getData();
      });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    goAllDoctor(key) {
      this.$router.push({
        path: "/project/all/doctor",
        query: { the_id: key }
      });
    },
    goVersions(key) {
      this.$router.push({ path: "/project/versions", query: { the_id: key } });
    },
    edit(key) {
      this.$router.push({ path: "/project/add", query: { the_id: key } });
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter(item => key === item.key)[0];
      const targetCache = newCacheData.filter(item => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter(item => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    }
  }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>